import * as React from 'react';

import useModalAccessibility from '../../Shared/hooks/useModalAccessibility'
import { CalendarDatePicker, Checkbox } from '../../Shared';

const BulkArchiveClassesModal = ({ handleBulkArchiveClasses, handleCloseModal }) => {
  const { modalRef } = useModalAccessibility(handleCloseModal);

  const [selectedDate, setSelectedDate] = React.useState<Date>(new Date());
  const [checkboxSelected, setCheckboxSelected] = React.useState<boolean>(false)

  function setDate(date) {
    setSelectedDate(date)
  }

  function handleArchiveClasses() {
    handleBulkArchiveClasses(selectedDate)
  }

  function handleCheckboxClick() {
    setCheckboxSelected(!checkboxSelected)
  }

  return (
    <div className="modal-container admin-action-modal-container admin-bulk-archive-classes-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="modalTitle"
        aria-modal="true"
        className="admin-bulk-archive-classes-modal quill-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="admin-action-modal-header">
          <h3 className="title" id="modalTitle">Archive Classes</h3>
          <img alt="warning icon" src="https://assets.quill.org/images/icons/s/warning.svg" />
        </div>
        <div className="admin-action-modal-body modal-body">
          <p>Please select a date. All classes owned by the selected teachers that were created before the selected date will be archived.</p>
          <CalendarDatePicker
            date={selectedDate}
            handleSetDate={setDate}
          />
          <section>
            <p>Teachers can un-archive classes on the <strong>Manage Classes</strong> page.</p>
            <p>If you do not want to archive classes for the selected teachers, please click the <strong>Cancel</strong> button.</p>
            <p>If you would like to proceed with archiving classes for the selected teachers, select the checkbox and click the <strong>Archive classes</strong> button.</p>
          </section>
          <Checkbox
            label="I understand that the selected teachers' classes created before the selected date and any associated student data will be archived and no longer available in data reports."
            onClick={handleCheckboxClick}
            selected={checkboxSelected}
          />
        </div>
        <div className="admin-action-modal-footer">
          <div className="buttons">
            <button
              className="quill-button outlined medium grey focus-on-light"
              onClick={handleCloseModal}
              type="button"
            >
              Cancel
            </button>
            <button
              className={`quill-button contained medium green focus-on-light ${checkboxSelected ? '' : 'disabled'}`}
              disabled={!checkboxSelected}
              onClick={handleArchiveClasses}
              type="button"
            >
              Archive classes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkArchiveClassesModal;
